import type React from "react";

import { cn } from "../lib/utils";
import { Container } from "./ui/container";

export interface PageContainerProps {
  children: React.ReactNode;
  className?: string;
}

// The "main content" piece of the PageHeader / PageContainer / PageFooter
// triad. Every page gets the same width (Container); phones get a slimmer
// 12px gutter so cards run nearly edge to edge, like an app. The page starts
// 24px under the header at every size.
export function PageContainer({ children, className }: PageContainerProps) {
  return (
    <main className="flex-1 pt-6 pb-6 sm:pb-14">
      <Container className={cn("px-3 sm:px-8 lg:px-4", className)}>{children}</Container>
    </main>
  );
}
